<template>
  <div>
    <div class="emd-container _highlight_header">
      <div class="emd-container__header">
        <h2 class="emd-text _size_default _type_caption">
          {{ $t('title') }}
        </h2>
      </div>
      <div class="eu-ml_3 eu-mb_1">
        <transaction-timeline-item
          v-if="transactions.length > 0"
          :transactions="transactions"
          @item="openDrawer"
        />
      </div>
    </div>
  </div>
</template>
<script>
import TransactionTimelineItem from './TransactionTimelineItem.vue'

export default {
  name: 'TransactionTimeline',
  components: {
    TransactionTimelineItem
  },
  props: {
    transactions: {
      type: Array,
      default: null
    }
  },
  methods: {
    openDrawer (data) {
      this.$emit('openDrawer', data)
    }
  }
}
</script>
<i18n>
    {
      "pt-BR": {
        "title": "Histórico da cobrança"
      },
      "en-US": {
        "title": "Charges history"
      }
    }
</i18n>
